export const featureToggle = {
    USER_LOGIN_ENABLED : false
};